export declare namespace InspectionTagTokenSections {
	interface Scheduled {
		background: string;
		borderColor: string;
	}

	interface Unscheduled {
		background: string;
		borderColor: string;
	}

	interface Inspection {
		background: string;
		borderColor: string;
	}

	interface Supervision {
		background: string;
		borderColor: string;
	}

	interface Monitoring {
		background: string;
		borderColor: string;
	}
}

export type InspectionTagTokens = {
	color: string;
	scheduled: InspectionTagTokenSections.Scheduled;
	unscheduled: InspectionTagTokenSections.Unscheduled;
	inspection: InspectionTagTokenSections.Inspection;
	supervision: InspectionTagTokenSections.Supervision;
	monitoring: InspectionTagTokenSections.Monitoring;
};

export const scheduled: InspectionTagTokenSections.Scheduled = {
	background: '{primary.300}',
	borderColor: '{primary.100}',
};

export const unscheduled: InspectionTagTokenSections.Unscheduled = {
	background: '{primary.700}',
	borderColor: '{primary.400}',
};

export const inspection: InspectionTagTokenSections.Inspection = {
	background: '{surface.300}',
	borderColor: '{surface.200}',
};

export const supervision: InspectionTagTokenSections.Supervision = {
	background: '{orange.400}',
	borderColor: '{orange.100}',
};

export const monitoring: InspectionTagTokenSections.Monitoring = {
	background: '{green.400}',
	borderColor: '{green.100}',
};

/** `app-inspection-kind` / `app-inspection-type` pill colours (`css/inspectionTag`). */
export default {
	color: '{primary.contrast.color}',
	scheduled,
	unscheduled,
	inspection,
	supervision,
	monitoring,
} satisfies InspectionTagTokens;
